export const rubrosHistoricos = [
    {
        "anio" : "2026",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2026/PRIMER TRIMESTRE 2026 SSH.zip"
            },
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2025/PRIMER TRIMESTRE 2025 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2025/SEGUNDO TRIMESTRE 2025 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2025/TERCER TRIMESTRE 2025 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2025/CUARTO TRIMESTRE 2025 SSH.zip"
            },
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2024/PRIMER TRIMESTRE 2024 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2024/SEGUNDO TRIMESTRE 2024 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2024/TERCER TRIMESTRE 2024 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2024/CUARTO TRIMESTRE 2024 SSH.zip"
            },
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2023/PRIMER TRIMESTRE 2023 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2023/SEGUNDO TRIMESTRE 2023 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2023/TERCER TRIMESTRE 2023 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2023/CUARTO TRIMESTRE 2023 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2022/PRIMER TRIMESTRE 2022 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2022/SEGUNDO TRIMESTRE 2022 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2022/TERCER TRIMESTRE 2022 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2022/CUARTO TRIMESTRE 2022 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2021/PRIMER  TRIMESTRE 2021 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2021/SEGUNDO  TRIMESTRE 2021 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2021/TERCER  TRIMESTRE 2021 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2021/CUARTO  TRIMESTRE 2021 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2020/PRIMER  TRIMESTRE 2020 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2020/SEGUNDO TRIMESTRE 2020 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2020/TERCER TRIMESTRE 2020 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2020/CUARTO TRIMESTRE 2020 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2019/PRIMER  TRIMESTRE 2019 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2019/SEGUNDO TRIMESTRE 2019 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2019/TERCER TRIMESTRE 2019 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2019/CUARTO TRIMESTRE 2019 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "/TransparenciaSSH/zip/2018/PRIMER TRIMESTRE 2018 SSH.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "/TransparenciaSSH/zip/2018/SEGUNDO TRIMESTRE 2018 SSH.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "/TransparenciaSSH/zip/2018/TERCER TRIMESTRE 2018 SSH.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "/TransparenciaSSH/zip/2018/CUARTO TRIMESTRE 2018 SSH.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "/TransparenciaSSH/zip/informacion historica 21 rubros SSH.zip"
            }
        ]
    }
]